<section class="add-billing-container policy-selector-container">
  <div class="billing-title">
    {{'Billing' | translate}}
  </div>
  <div class="add-billing-text">{{'Select a policy to check billing details' | translate}}</div>

  <hr *ngIf="!showTabs" class="devided-line">

  <div class="policy-selector-body">
    <ng-container *ngIf="showTabs">
      <div class="billing-navs policy-selector-tabs">
        <nav class="billing-details-nav">
          <a class="billing-nav-tab overview"
            [ngClass]="{'active': selectedTab === 'active'}"
            (click)="selectTab('active')"
          >
            {{'Active policies' | translate}}
          </a>

          <a class="billing-nav-tab"
            [ngClass]="{'active': selectedTab === 'inactive'}"
            (click)="selectTab('inactive')"
          >
            {{'Inactive policies' | translate}}
          </a>
        </nav>
        <div class="empty-nav-div"></div>
      </div>
    </ng-container>

    <div class="policy-list-wrapper" [ngClass]="{'scrollable': isScrollable}">
      <div class="policy-list" [ngClass]="{'scrollable': isScrollable}" role="tabpanel" #policyListEl
        (scroll)="onListScroll()"
        [attr.id]="showTabs ? (selectedTab === 'active' ? 'active-policies-panel' : 'inactive-policies-panel') : null"
        [attr.aria-labelledby]="showTabs ? (selectedTab === 'active' ? 'active-policies-tab' : 'inactive-policies-tab') : null">
        <ng-container *ngFor="let policy of visiblePolicies">
          <div class="policy-row" tabindex="0" role="link"
            [attr.aria-label]="'View policy ' + getPolicyTypeLabel(policy)" (click)="viewPolicy(policy)"
            (keydown.enter)="viewPolicy(policy)">
            <div class="policy-row-left">
              <img [src]="getPolicyIcon(policy)" width="32" height="32" [alt]="(policy?.policyType || '') + ' icon'" />
              <div class="policy-type-num-term-block web-display">
                <div class="policy-type-num-row">
                  <span class="policy-row-width">
                    {{ getPolicyTypeLabel(policy) | translate }} &ndash; {{ policy?.policynumber?.policyNumber }}
                  </span>
                  <span class="status-pill" *ngIf="showStatusPill"
                    [ngClass]="hasActive ? 'status-active' : 'status-inactive'">
                    {{ getStatusLabel() | translate }}
                  </span>
                </div>
                <div class="policy-term-row" *ngIf="policy?.effDate && policy?.expDate">
                  {{ policy?.effDate | customDateFormat }}&ndash;{{ policy?.expDate | customDateFormat }}
                </div>
              </div>
              <div class="policy-type-num-term-block mobile-display">
                <div class="policy-type-num-row">
                  <span>{{ getPolicyTypeLabel(policy) | translate }}</span>
                  <span class="status-pill" *ngIf="showStatusPill"
                    [ngClass]="hasActive ? 'status-active' : 'status-inactive'">
                    {{ getStatusLabel() | translate }}
                  </span>
                </div>
                <div class="policy-num-term-row policy-term-row">
                  <span class="mobile-policy-num"> {{ policy?.policynumber?.policyNumber }}</span>
                  <span *ngIf="policy?.effDate && policy?.expDate">
                    {{ policy?.effDate | customDateFormat }}&ndash;{{ policy?.expDate | customDateFormat }}
                  </span>
                </div>
              </div>
            </div>
            <div class="policy-row-action">
              <span class="view-policy-link">{{'View policy' | translate}}</span>
              <span class="arrow-block">
                <img
                  [src]="isAcmic ? 'assets/img/images/widgets/select-arrow-acmic.svg' : 'assets/img/images/widgets/select-arrow.svg'"
                  alt="view policy chevron" />
              </span>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="policy-list-custom-scrollbar-track" *ngIf="isScrollable">
        <div class="policy-list-custom-scrollbar-thumb" [style.height.%]="thumbHeightPercent"
          [style.top.%]="thumbTopPercent" (mousedown)="onThumbMouseDown($event)">
        </div>
      </div>
    </div>
  </div>

  <app-add-missing-policy></app-add-missing-policy>

  <app-billing-assistance-cards [company]="company" [isAcmic]="isAcmic">
  </app-billing-assistance-cards>
</section>